import { brandSecondary, darkGrayFontColor, titles, warningDark, warningLight } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		position: 'relative',
		width: 460,
	},
	header: {
		textAlign: 'right',
	},
	title: {
		color: brandSecondary,
		fontSize: 18,
		lineHeight: '22px',
		marginBottom: 16,
	},
	content: {
		paddingBottom: 30,
	},
	message: {
		alignItems: 'center',
		color: titles,
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: 16,
		gap: 6,
		lineHeight: '24px',
		marginBottom: 12,
	},
	subMessage: {
		color: darkGrayFontColor,
		fontSize: 14,
		lineHeight: '20px',
		marginBottom: 30,
	},
	removingMessage: {
		alignItems: 'center',
		display: 'flex',
		paddingBottom: 30,
		...CssSelectors.allDescendants(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	buttonContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: 12,
		justifyContent: 'flex-end',
	},
	cancelButton: {
		minWidth: 100,
	},
	confirmButton: {
		minWidth: 150,
	},
	tagSelectionContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		marginBottom: 20,
		marginTop: 16,
	},
	tagCheckboxLabel: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		gap: 8,
	},
	tagCheckboxLabelLocked: {
		cursor: 'not-allowed',
		opacity: 0.6,
	},
	lockBadge: {
		alignItems: 'center',
		display: 'inline-flex',
		marginLeft: 4,
	},
	lockedWarning: {
		alignItems: 'flex-start',
		backgroundColor: warningLight,
		border: `1px solid ${warningDark}`,
		borderRadius: 4,
		color: titles,
		display: 'flex',
		fontSize: 13,
		gap: 8,
		lineHeight: '18px',
		marginBottom: 16,
		padding: '10px 12px',
	},
	lockedInfoMessage: {
		color: titles,
		fontSize: 16,
		lineHeight: '28px',
		marginBottom: 20,
	},
	lockedInfoTag: {
		display: 'inline-flex',
		margin: '0 4px',
		verticalAlign: 'middle',
	},
});
